import React, { useState } from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { toast } from 'sonner';

// Download IconButton that calls the affidavit endpoint and navigates to the
// returned presigned URL via the configurable openURL prop. Stops row click
// propagation so the modal doesn't open underneath the download.
export const DownloadAffidavitButton = ({ appId, trustCheckSessionId, api_client, openURL, t }) => {
    const [downloading, setDownloading] = useState(false);
    const handleClick = async (e) => {
        e.stopPropagation();
        if (downloading) return;
        setDownloading(true);
        try {
            // The /download endpoint returns a 302 to a presigned URL. axios follows
            // redirects by default, so the final response carries the resolved URL —
            // but we don't want axios to fetch the bytes (binary). The spec endpoint
            // returns JSON `{url: ...}` in the post-spec UI contract; we accept either
            // shape so the front-end is forgiving while the backend lands.
            const response = await api_client.get(`/v2/affidavits/${appId}/${trustCheckSessionId}/download`);
            const url = response?.data?.url || response?.request?.responseURL;
            if (url) {
                openURL(url);
            } else {
                toast(t ? t('callLogs.failedToDownloadCertificate') : 'Failed to download certificate', { type: 'error' });
            }
        } catch (err) {
            console.error('Affidavit download failed', err);
            toast(t ? t('callLogs.failedToDownloadCertificate') : 'Failed to download certificate', { type: 'error' });
        } finally {
            setDownloading(false);
        }
    };
    return (
        <Tooltip title={t ? t('callLogs.downloadCertificate') : 'Download Certificate'}>
            <span>
                <IconButton
                    size="small"
                    onClick={handleClick}
                    disabled={downloading}
                    data-testid="trust-check-download"
                    aria-label={t ? t('callLogs.downloadCertificate') : 'Download Certificate'}
                >
                    {downloading ? <CircularProgress size={16} /> : <DownloadIcon fontSize="small" />}
                </IconButton>
            </span>
        </Tooltip>
    );
};
